export const controlDeviceReferencedDeliverablesSelector = state => state.entities.controlDeviceReferencedDeliverables;
